export default "__VITE_ASSET__CdpByTzW__"